/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取设备列表
export function getDeviceList(params) {
    return request({
        url: 'aiot/device/list.do?',
        method: 'post',
        data: params
    })
}

// 获取设备详情
export function getDeviceDetail(params) {
    return request({
        url: 'aiot/device/detail.do?',
        method: 'post',
        data: params
    })
}

// 获取设备属性
export function getDeviceProperty(params) {
    return request({
        url: 'aiot/property/latest/query.do?',
        method: 'post',
        data: params
    })
}

// 设置WiFi开关
export function setWifiEnabled(params) {
    return request({
        url: 'aiot/property/wifi-enabled/set.do?',
        method: 'post',
        data: params
    })
}

// 设置WiFi热点显示/隐藏
export function setWifiHidden(params) {
    return request({
        url: 'aiot/property/hidden/set.do?',
        method: 'post',
        data: params
    })
}

// 设置设备在线状态
export function setDeviceConnStatus(params) {
    return request({
        url: 'aiot/property/device-conn-status/set.do?',
        method: 'post',
        data: params
    })
}

// 关机
export function poweroffDevice(params) {
    return request({
        url: 'aiot/service/poweroff.do?',
        method: 'post',
        data: params
    })
}

// 恢复出厂
export function factoryResetDevice(params) {
    return request({
        url: 'aiot/service/factory-reset.do?',
        method: 'post',
        data: params
    })
}

// 重启设备
export function resetDevice(params) {
    return request({
        url: 'aiot/service/reset.do?',
        method: 'post',
        data: params
    })
}

// 新增设备
export function createDevice(params) {
    return request({
        url: 'aiot/device/create.do?',
        method: 'post',
        data: params
    })
}

// 删除设备
export function deleteDevice(params) {
    return request({
        url: 'aiot/device/delete.do?',
        method: 'post',
        data: params
    })
}

